export enum InMailFolderEnum {
  Inbox,
  Outbox,
  Deleted,
  Saved
}
